define(['jquery', 'jquery.transit', 'modernizr', 'container', 'preloader', 'router', 'scroll', 'form-validator', 'jump'],
    function ($, transit, modernizr, container, preloader, router, scroll, formValidatorFactory, jumpFactory) {

        var module = (function () {

            var name = 'module-partner-with-us-featured';

            var model = container.getBaseModel(name);
            var view = container.getBaseView(name);
            var pubSub = container.getPublishSubscribe();
            var formValidator = formValidatorFactory.create();
            var jump = jumpFactory.create();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {
                sendForm: (fd) => {
                    container.msg(name + ' - send form');
                    $.ajax({
                        url: model.publicVars.formSendEndpoint,
                        type: 'POST',
                        processData: false,
                        contentType: false,
                        data: fd
                    }).done(function () {
                        container.msg(name + ' - send form done');
                        pubSub.publish('view/sendFormDone', {});
                    });
                }
            }

            /* view */

            view.publicVars = {};

            view.privateVars = {

            };

            view.startup = function () {
                // scroll.registerAnimatedElement(view.publicVars.cssId.anim.modulePartnerWithUsFeaturedHeaderMenuId, 'animate__faster animate__fadeIn', 'partner-with-us-featured', {});
                scroll.registerAnimatedElement(view.publicVars.cssId.anim.modulePartnerWithUsFeaturedAnimMainId, 'animate__faster animate__zoomIn', 'partner-with-us-featured', {});
            };

            view.bind = function () {
                $(view.publicVars.cssId.form.modulePartnerWithUsFeaturedFormRowSubmitId).click(function () {
                    view.methods.form.handleFormSubmit();
                });
            };

            view.methods = {
                form: {
                    handleFormSubmit: () => {
                        const requiredObj = {
                            1: {
                                field: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextFirstNameId,
                                defaultValue: '',
                                errorField: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextFirstNameId,
                                errorClass: view.publicVars.cssId.form.hasErrorCls.substr(1),
                            },
                            2: {
                                field: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextLastNameId,
                                defaultValue: '',
                                errorField: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextLastNameId,
                                errorClass: view.publicVars.cssId.form.hasErrorCls.substr(1),
                            },
                            3: {
                                field: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextEmailId,
                                defaultValue: '',
                                errorField: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextEmailId,
                                errorClass: view.publicVars.cssId.form.hasErrorCls.substr(1),
                            },
                            4: {
                                field: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextCompanyId,
                                defaultValue: '',
                                errorField: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextCompanyId,
                                errorClass: view.publicVars.cssId.form.hasErrorCls.substr(1),
                            },
                            5: {
                                field: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextTitleId,
                                defaultValue: '',
                                errorField: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextTitleId,
                                errorClass: view.publicVars.cssId.form.hasErrorCls.substr(1),
                            },
                            6: {
                                field: view.publicVars.cssId.form.modulePartnerWithUsFeaturedTextareaQuestionId,
                                defaultValue: '',
                                errorField: view.publicVars.cssId.form.modulePartnerWithUsFeaturedTextareaQuestionId,
                                errorClass: view.publicVars.cssId.form.hasErrorCls.substr(1),
                            },
                        };

                        const emailObj = {
                            1: {
                                field: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextEmailId,
                                defaultValue: '',
                                errorField: view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextEmailId,
                                errorClass: view.publicVars.cssId.form.hasErrorCls.substr(1),
                                isRequired: true
                            }
                        };

                        formValidator.set('required', requiredObj);
                        formValidator.set('email', emailObj);

                        const validation = formValidator.validate();

                        if($(window).width() < 1025) {
                            let jumpFlag = false;

                            for (let key in validation.fieldStatus.required) {

                                if (validation.fieldStatus.required[key].status === false && !jumpFlag) {
                                    jumpFlag = true;

                                    jump.centerTo(validation.fieldStatus.required[key].field);
                                }
                            }

                            for (var key in validation.fieldStatus.email) {

                                if (validation.fieldStatus.email[key].status === false && !jumpFlag) {
                                    jumpFlag = true;

                                    jump.centerTo(validation.fieldStatus.email[key].field);
                                }
                            }
                        }

                        if (validation['validFlag']) {

                            $(view.publicVars.cssId.containerWrapperId).addClass(view.publicVars.cssId.isInactiveCls.substr(1));

                            let fd = new FormData();

                            fd.append('first_name', $(view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextFirstNameId).val());
                            fd.append('last_name', $(view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextLastNameId).val());
                            fd.append('email', $(view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextEmailId).val());
                            fd.append('company', $(view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextCompanyId).val());
                            fd.append('title', $(view.publicVars.cssId.form.modulePartnerWithUsFeaturedInputTextTitleId).val());
                            fd.append('question', $(view.publicVars.cssId.form.modulePartnerWithUsFeaturedTextareaQuestionId).val());
                            fd.append('rand', view.publicVars.rand);

                            model.methods.sendForm(fd);
                        }
                    },

                    sendFormDone: () => {
                        $(view.publicVars.cssId.modulePartnerWithUsFeaturedFormId).css({ display: 'none'});
                        $(view.publicVars.cssId.modulePartnerWithUsFeaturedFormThxId).css({ display: 'block'});
                        $(view.publicVars.cssId.modulePartnerWithUsFeaturedInnerCls).addClass(view.publicVars.cssId.isThxCls.substr(1));

                        if($(window).width() < 1025) {
                            jump.centerTo(view.publicVars.cssId.modulePartnerWithUsFeaturedFormThxId);
                        }

                        $(view.publicVars.cssId.containerWrapperId).removeClass(view.publicVars.cssId.isInactiveCls.substr(1));
                    }
                },
            };

            /* custom events */
            pubSub.subscribe('view/sendFormDone', view.methods.form.sendFormDone);
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                    scroll.init();
                }
            };


        })();

        return module;


    });
